import {Button} from '@material-ui/core';
import {CircularProgress} from '@material-ui/core';
import classNames from 'classnames';
import {identity} from 'fp-ts/lib/function';
import {fold as foldOption, Option} from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {ReactNode, useState} from 'react';
import {FilterFieldDefinitions} from 'Shared/components/Table/Table';
import './FilterResultsDialog.sass';

type FilterResultsDialogProps<TFilter> = {
  filter?: TFilter;
  filters?: FilterFieldDefinitions<TFilter>;
  totalResults: Option<number>;
  onClose: () => void;
};

export default <TFilter extends {}>(props: FilterResultsDialogProps<TFilter>) => {
  const [isFakeClosed, setIsFakeClosed] = useState(false);

  return props.filters && props.filters.length > 0 ? (
    <div
      className={classNames('filter-results-dialog__content', {
        slideClosed: isFakeClosed,
        slideIn: !isFakeClosed,
      })}
    >
      <h3 style={{marginTop: '2rem', textAlign: 'center'}}>
        Total Results: &nbsp;
        {pipe(
          props.totalResults,
          foldOption(() => <CircularProgress /> as ReactNode, identity)
        )}
      </h3>
      {props.filters && props.filters.map(filter => filter.renderFilter(props.filter!))}
      <Button
        className="filter-results-dialog__close-button"
        fullWidth
        color="primary"
        variant="contained"
        onClick={() => {
          setIsFakeClosed(true);
          setTimeout(props.onClose, 1000);
        }}
      >
        Close
      </Button>
    </div>
  ) : null;
};
